<template>
  <svg :width="24" :height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12.2785 1.66888C12.0997 1.59735 11.9003 1.59735 11.7215 1.66888L2.76944 5.24968L12 8.94191L21.2306 5.24968L12.2785 1.66888ZM22.5 6.35746L12.75 10.2575V22.1419L22.5 18.2419V6.35746ZM11.25 22.1419V10.2575L1.5 6.35746V18.2419L11.25 22.1419ZM11.1644 0.276162C11.7008 0.0615919 12.2992 0.0615919 12.8356 0.276162L23.5285 4.55333C23.8133 4.66722 24 4.94301 24 5.24968V18.2419C24 18.8553 23.6266 19.4068 23.0571 19.6346L12.2785 23.946C12.0997 24.0176 11.9003 24.0176 11.7215 23.946L0.942914 19.6346C0.373427 19.4068 0 18.8553 0 18.2419V5.24968C0 4.94301 0.186713 4.66722 0.471457 4.55333L11.1644 0.276162Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  name: 'DeliveriesIcon'
}
</script>